import styled from '@emotion/styled';

export const Root = styled.div<{ open: boolean }>`
  align-items: center;
  background: rgba(51, 51, 51, 0.66);
  display: ${props => (props.open ? 'flex' : 'none')};
  height: 100vh;
  justify-content: center;
  left: 0;
  padding: 0 16px;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 99999;
  input {
    width: 100%;
    height: 40px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 5px;
    padding: 12px 16px;
  }
  .ui.label.ui.label {
    border-color: #e8e8e8;
    box-shadow: none;
    border: none;
    height: 28px;
    font-weight: 400;
    font-size: 14px;
    color: #333;
    display: inline-flex;
    align-items: center;
    margin-bottom: 6px;
    margin-right: 6px;
  }
`;

export const Tile = styled.div`
  background-color: #fff;
  border-radius: 5px;
  color: #444;
  max-width: 600px;
  width: 100%;
  .header {
    align-items: center;
    border-bottom: 1px solid #e5e5ea;
    display: flex;
    font-size: 16px;
    font-weight: 700;
    justify-content: space-between;
    padding: 16px 24px;
    svg {
      cursor: pointer;
    }
  }
`;

export const FormWrap = styled.div`
  padding: 8px 24px 24px;
  input {
    border: 1px solid #e5e5ea;
    display: block;
    outline: none;
  }
  .label {
    margin-bottom: 8px;
    margin-top: 16px;
  }
`;

export const SelectSearchersWrap = styled.div`
  align-items: center;
  border-radius: 5px;
  border: 1px solid #e5e5ea;
  display: flex;
  flex-wrap: wrap;
  padding: 12px 16px;
  padding-bottom: 4px;
  position: relative;
  .addSearch {
    align-items: center;
    border-radius: 5px;
    border: 1px dashed #e5e5ea;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    height: 30px;
    margin-right: 8px;
    margin-bottom: 8px;
    padding: 0 8px;
    transition: all 0.1s;
    :hover {
      border: 1px dashed #ff5252;
      color: #ff5252;
    }
    svg {
      margin-right: 8px;
    }
  }
`;

export const SelectPropertiesWrap = styled.div`
  align-items: center;
  border-radius: 5px;
  border: 1px solid #e5e5ea;
  display: flex;
  flex-wrap: wrap;
  padding: 12px 16px;
  padding-bottom: 8px;
  position: relative;
`;

export const Chip = styled.div`
  align-items: center;
  background: #e5e5ea;
  border-radius: 5px;
  color: #333;
  display: flex;
  font-weight: 400;
  height: 30px;
  justify-content: center;
  margin-right: 8px;
  padding: 0 8px;
  margin-bottom: 8px;
  svg {
    cursor: pointer;
    margin-left: 8px;
    max-width: 11px;
  }
`;

export const ButtonSection = styled.div`
  border-top: 1px solid #e5e5ea;
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px;
  button {
    align-items: center;
    background-color: #333;
    border-radius: 5px;
    color: #fff;
    display: flex;
    font-weight: 700;
    height: 40px;
    padding: 0 16px;
    cursor: pointer;
    border: none;
    outline: none;
    :hover {
      background-color: #222;
    }
  }
`;

export const NotesInput = styled.textarea`
  background: #ffffff;
  height: 120px;
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  width: 100%;
  padding: 12px 16px;
  resize: none;
  ::placeholder {
    color: #e5e5ea;
  }
`;
